import { FormGroup, InputLabel } from "@mui/material";
import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./country-code-phone-numner-input.scss";
import { extractCountryAndNumber } from "../../../utils/utils";

interface CountryCodeWithPhoneNumberProps {
  optional?: boolean;
  fieldName: string;
  label?: string;
  countryCodeEditable?: boolean;
  onChange?: (value: string, country: any, e: any, formattedValue: any) => void;
  enableSearch?: boolean;
  placeholder?: string;
  disableSearchIcon?: boolean;
  value: string;
  defaultCountry?: string | undefined | number;
  disabled?: boolean;
  key?: any;
  onKeyDown?: any;
  onBlur?: () => void;
  isRequired?: boolean;
}

const placeHolder: any = {
  1: "20px",
  2: "60px",
  3: "70px",
  4: "75px",
  5: "80px",
};

const CountryCodeWithPhoneNumber: React.FC<CountryCodeWithPhoneNumberProps> = ({
  optional = false,
  fieldName,
  label,
  placeholder,
  enableSearch = true,
  countryCodeEditable = false,
  disableSearchIcon = true,
  onChange,
  value,
  defaultCountry = "us",
  disabled,
  key,
  onKeyDown,
  onBlur,
  isRequired = false,
}) => {
  const countePhoneObj = extractCountryAndNumber(value);
  const countryCodeLength = countePhoneObj?.countryCode?.length;
  const isEmpty = value.trim() === "" || !countePhoneObj?.number?.length;
  return (
    <FormGroup>
      {label && (
        <InputLabel
          required={!optional}
          htmlFor={fieldName}
          className="phone-label"
        >
          {label}
        </InputLabel>
      )}
      <div
        className={`phone-input-wrapper ${isRequired ? "phone-input-wrapper-required" : ""}`}
      >
        {isEmpty && (
          <span
            className="phone-placeholder"
            style={{
              left: placeHolder?.[countryCodeLength] || "60px",
            }}
          >
            {placeholder}
          </span>
        )}
        <PhoneInput
          country={defaultCountry}
          value={value || ""}
          countryCodeEditable={countryCodeEditable}
          onChange={onChange}
          enableSearch={enableSearch}
          disableSearchIcon={disableSearchIcon}
          placeholder={placeholder}
          disabled={disabled}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          inputProps={{
            name: fieldName,
            required: !optional,
            autoComplete: "off",
          }}
          inputStyle={{
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            paddingLeft: "48px",
          }}
          buttonStyle={{
            border: "none",
            backgroundColor: "transparent",
          }}
          dropdownStyle={{
            position: "absolute",
            textAlign: "left",
          }}
          inputClass="phone-input"
        />
      </div>
    </FormGroup>
  );
};

export default CountryCodeWithPhoneNumber;
